module.exports = __webpack_public_path__ + "static/img/certificate02.18e75089.jpeg";